import React from "react";
import Styled from "./index.style";

const ButtonCommon = ({ children, ...restProps }) => {
  return <Styled {...restProps}>{children}</Styled>;
};

export default ButtonCommon;
